import React from "react";
import { Button, Grid, TextField, Typography } from "@mui/material";
import "../../assets/css/icon.css";

const ModalNewPractice = ({
  onClose,
  confirm,
  handlePracticeUpdate,
  practice,
  errors,
}) => {
  const handlePracticeChange = (name, value) => {
    const updatedPractice = {
      ...practice,
      Incarico: {
        ...practice?.Incarico,
        [name]: value,
      },
    };

    handlePracticeUpdate(updatedPractice);
  };

  return (
    <Grid
      container
      item
      xs={11}
      md={5}
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#fff",
        maxHeight: "800px",
        width: { xs: "90%", sm: "80%" },
      }}
    >
      <Grid
        item
        xs={12}
        style={{
          height: "60px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #c6c6c6",
        }}
      >
        <Grid item xs={1} style={{ marginLeft: "15px" }}>
          <div className="icon-modal-info" />
        </Grid>
        <Grid item xs={10}>
          <Typography
            className="color-blue-dark"
            style={{ fontSize: "18px", fontWeight: 600 }}
          >
            Nuova richiesta
          </Typography>
        </Grid>
        <Grid
          item
          xs={1}
          style={{
            marginRight: "15px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <div onClick={onClose} className="icon-modal-close" />
        </Grid>
      </Grid>

      <Typography
        style={{
          padding: "10px 15px 0px 15px",
          marginTop: "20px",
        }}
        className="color-blue-dark"
      >
        Inserisci il nome della pratica. <br />
        Il nome della pratica deve essere così composto: Cliente / Prodotto +
        Specifica eventuale. <br />
        Esempi: Mario Rossi / Costituzione di startup innovativa; Alfa Srl /
        Contratto di investimento Beta Spa. <br />
        Non preoccuparti, potrai modificare il nome della pratica in seguito.
      </Typography>

      <div
        style={{
          display: "flex",
          padding: "0px 15px",
          marginTop: "20px",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <Typography className="color-blue-dark title-input">
          Nome della pratica
        </Typography>
        <TextField
          style={{
            marginTop: "10px",
            width: "75%",
          }}
          placeholder="Inserisci"
          variant="outlined"
          error={errors.includes("Nome_pratica")}
          fullWidth
          name="Nome_pratica"
          value={practice?.Incarico?.Nome_pratica || ""}
          onChange={(e) => handlePracticeChange(e.target.name, e.target.value)}
        />
        {errors.includes("Nome_pratica") && (
          <Typography
            className="color-purple"
            style={{
              marginTop: "5px",
              fontSize: "14px",
            }}
          >
            Il campo è obbligatorio
          </Typography>
        )}
      </div>

      <Grid container item xs={12} style={{ marginTop: "20px" }}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "20px",
          }}
        >
          <Button className="button-bg-purple" onClick={confirm}>
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              Inizia
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModalNewPractice;
